<app-ehe-verification-modal
	(action)="actionFunction($event)"
	[title]="'ADD A PREFERRED LOCATION'"
	[button1]="'Add'"
	[button2]="'Cancel'">
	<div class="add-location-wrapper">
		<div>
			<form [formGroup]="locationForm">
				<div>
					<div class="address-option">
						<div class="container">
							<div class="row">
								<div class="col-md-4">
									<mat-form-field>
										<mat-label>City</mat-label>
										<input matInput formControlName="city" />
										<mat-error>
											<app-error-message [control]="'city'"></app-error-message>
										</mat-error>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field>
										<mat-label>State</mat-label>
										<mat-select disableOptionCentering panelClass="custom-material-position" formControlName="state">
											<mat-option *ngFor="let state of data.states" [value]="state">{{ state }}</mat-option>
										</mat-select>
										<mat-error>
											<app-error-message [control]="'state'"></app-error-message>
										</mat-error>
									</mat-form-field>
								</div>
								<div class="col-md-4">
									<mat-form-field>
										<mat-label>Zip Code</mat-label>
										<input matInput formControlName="zipCode" [imask]="zipMask.iMaskArgs" />
										<mat-error>
											<app-error-message [control]="'zipCode'"></app-error-message>
										</mat-error>
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</app-ehe-verification-modal>
